import { useMutation, useQueryClient } from '@tanstack/react-query'

import { errorToast, successToast } from 'common/components/toastNotification'

import { contentKeys } from '../queryKeys'
import { deleteContent } from '..'

const useDeleteContentMutation = () => {
  const queryClient = useQueryClient()

  return useMutation(
    ({ accountId, contentId }: { accountId: string; contentId: string }) =>
      deleteContent({ accountId, contentId }),
    {
      onError: () => {
        errorToast('Something went wrong. Please try again.')
      },
      onSuccess: () => {
        successToast('Content deleted successfully.')
      },
      onSettled: () => {
        queryClient.invalidateQueries(contentKeys.contentLibraryAll())
      },
    }
  )
}

export default useDeleteContentMutation
